import styles from "./AccountsDropdown.module.scss";
import React from "react";
import {AppStaticDropdown} from "./AppStaticDropdown";
import clsx from "clsx";

export const AccountsDropdown = ({value, onChange, accounts}) => {
  return <AppStaticDropdown
    value={value}
    choices={accounts}
    choiceValue={choice => choice.id}
    choiceLabel={choice => choice.name}
    choiceDisplay={AccountChoiceDisplay}
    onChange={onChange}
  />;
};

const AccountChoiceDisplay = account => {
  if (account.id) {
    return <div className={styles.choiceAccount}>
      <div className={styles.color} style={{background: account.color.split("|")[0]}}/>
      <div className={styles.name}>
        {account.name}

        {!account.active && <span className={clsx("material-icons", styles.inactiveIcon)}>visibility_off</span>}
      </div>
    </div>;
  } else {
    return <div className={styles.choiceAccount}>
      <div className={styles.name}>{account.name}</div>
    </div>;
  }
}
